import { render } from "./HowToTrigger.vue?vue&type=template&id=533e7996"
import script from "./HowToTrigger.vue?vue&type=script&lang=js"
export * from "./HowToTrigger.vue?vue&type=script&lang=js"

import "./HowToTrigger.vue?vue&type=style&index=0&id=533e7996&lang=css"
script.render = render

export default script